import { UserInfoOutDTO } from '@api/ringil-api.v2';

export const isNotAgent = (loggedUser: UserInfoOutDTO, entityOwnerCompanyId: string): boolean => {
  return loggedUser.companyId === entityOwnerCompanyId;
};
